function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M58.75 36.25h11.875v1.64H58.75zM58.75 32.969h11.875v1.64H58.75z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M50 5.469c-24.531 0-44.531 20-44.531 44.53s20 44.532 44.531 44.532S94.531 74.53 94.531 50 74.531 5.469 50 5.469zm-20 19.14c2.813 0 5.078 2.188 5.078 4.845S32.812 34.297 30 34.297s-5-2.187-5-4.843 2.266-4.844 5-4.844zm16.328 20.548c-.39.469-.938.469-1.094.469-1.797 0-3.672.078-5.469.078-1.484-1.25-2.968-2.5-4.53-3.672.155 5.156.234 10.312.39 15.469 0 .312-.235.469-.469.469h-.078c-.313 0-.469.234-.469.468v14.844c0 1.172-.937 2.031-2.11 2.031h-.859c-.625 0-1.093-.234-1.484-.625-.156-.156-.469-.156-.703 0-.234.235-.469.391-.781.47-.235.077-.47.155-.703.155h-.86c-1.172 0-2.11-.937-2.11-2.03V58.437c0-.312-.234-.468-.468-.468h-.625c-.313 0-.469-.235-.469-.47V39.143c0-2.11 1.64-3.828 3.672-3.828h5c.625 0 1.25.156 1.797.468.078 0 .156.079.156.079.782.546 5.39 5 6.953 6.562h4.22c.468 0 .859.156 1.093.469l9.687-7.5c.313-.235.704-.156.938.156s.156.703-.156.938L46.64 44.298c.078.234 0 .547-.313.86zm30.234 19.062h-5.625l-.39-.781-10.704-.157-.234.547h-6.875V62.5h6.016l6.172-13.672H54.61v-8.984l2.968-2.578c.703-.625.782-1.641.157-2.344s-1.641-.781-2.344-.156l-.781.703v-6.72h20.156v20.157h-9.454l6.563 13.984h4.687z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M58.75 39.531h11.875v1.64H58.75z"
});

function SvgInstructor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructor);
export default __webpack_public_path__ + "static/media/instructor.6c62551e.svg";
export { ForwardRef as ReactComponent };